import React from "react";

import { Grid } from "@mui/material";

import NoDataOverlay from "../../../../components/NoDataOverlay/NoDataOverlay";

interface NoGraphDataProps {
  title?: string;
  body?: string;
}
export const NoGraphData = ({ title, body }: NoGraphDataProps) => {
  return (
    <Grid
      container
      direction={"column"}
      alignItems={"center"}
      sx={{ marginTop: "60px" }}
      justifyContent={"center"}
      rowSpacing={2}
    >
      <NoDataOverlay
        message1={title ?? "No Data Yet!"}
        message2={
          body ??
          "Check back later, it may take up to two hours after experiment launch for data to appear."
        }
      />
    </Grid>
  );
};
